import type { BaseComponentProps, WithChildren } from "@neru/types";
import { deduplicateClass } from "@neru/utils";

type GridProps = BaseComponentProps &
  WithChildren & {
    columns?: number;
  };

export const Grid = ({
  children,
  className = "",
  columns = 2,
  "data-testid": testId = "grid",
}: GridProps) => {
  return (
    <div
      className={deduplicateClass(`grid gap-x-4 gap-y-8`, className)}
      data-testid={testId}
      style={{
        gridTemplateColumns: `repeat(auto-fill, minmax(max(280px, 100%/${columns + 1}), 1fr))`,
      }}
    >
      {children}
    </div>
  );
};
